<svg
  [attr.width]="size"
  [attr.height]="size"
  fill="none"
  viewBox="0 0 16 16"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M12 12L4 4M12 4L4 12"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
  />
</svg>
